import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import { useRef, useEffect } from 'react';
import './blog.css';



const blogData = [
  {
    id: 1,
    image: require('../../../assets/jornada_cientifica-7.jpeg'),
    time: '05, 07 e 08 de Maio de 2026',
    title: '7ª Jornada Científica Geral',
    description: 'A 7ª edição das Jornadas Científicas do ISPA, realizada nos dias 05, 07 e 08 de Maio de 2026, foi um evento marcante que reuniu a comunidade académica para debater estratégias e processos que incentivam o desenvolvimento sustentável das instituições.',
    link: '/eventos/1'
  },
  {
    id: 2,
    image: require('../../../assets/ANU_02.jpg'),
    time: '19-Dezembro-2025',
    title: '4.ª Cerimónia de Outorga',
    description: 'O Instituto Superior Politécnico Atlântida realizará, no dia 19 de Dezembro de 2025, a sua 4.ª Cerimónia de Outorga de Diplomas.',
    link: '/eventos/2'
  },
  {
    id: 9,
    image: require('../../../assets/ANU_04.jpg'),
    time: '07-Setembro-2023 ',
    title: '5ª Jornada Científica Geral',
    description: '"O evento proporcionou uma oportunidade única para a comunidade acadêmica trocar ideias, colaborar em projetos e promover o avanço do conhecimento científico. celebrando o início de sua jornada acadêmica com os veteranos.',
    link: '/eventos/9'
  }
]

function useAnimateOnScroll() {
  const refs = useRef([]);

  useEffect(() => {
    const handleScroll = () => {
      refs.current.forEach((ref) => {
        if (!ref) return;
        const rect = ref.getBoundingClientRect();
        const inView = rect.top < window.innerHeight - 40 && rect.bottom > 40;
        if (inView) {
          ref.classList.add('animate-in');
        } else {
          ref.classList.remove('animate-in');
        }
      });
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return refs;
}

const cardAnimationCSS = `
  .blog-block .card-animate {
    opacity: 0;
    transform: translateY(60px) scale(0.97);
    transition: 
      opacity 0.7s cubic-bezier(0.4,0,0.2,1),
      transform 0.7s cubic-bezier(0.4,0,0.2,1);
    will-change: opacity, transform;
  }
  .blog-block .card-animate.animate-in {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

function AppBlog() {
  const cardRefs = useAnimateOnScroll();

  useEffect(() => {
    const section = document.getElementById('blog');
    if (section) {
      section.classList.add('slide-down-in');
    }
  }, []);

  return (
    <section id="blog" className="block blog-block" style={{ padding: 'max(16px, 5vw)', border: 'none', background: 'linear-gradient(120deg, #f8fafc 60%, #d9f2e0 100%)'}}>
      <style>
        {cardAnimationCSS.replace('0.7s', '1.4s')}
        {`
          .blog-block {
            padding-left: max(16px, 5vw);
            padding-right: max(16px, 5vw);
            opacity: 0;
            transform: translateY(-60px);
            transition: opacity 0.8s cubic-bezier(0.4,0,0.2,1), transform 0.8s cubic-bezier(0.4,0,0.2,1);
            background: linear-gradient(120deg, #f8fafc 60%, #d9f2e0 100%);
          }
          .blog-block.slide-down-in {
            opacity: 1;
            transform: translateY(0);
          }
          .blog-block .title-holder {
            text-align: center;
            margin-bottom: 2.5rem;
            animation: pop-in-title 1s cubic-bezier(0.4,0,0.2,1);
          }
          .blog-block .title-holder .subtitle {
            font-size: 1.2rem;
            font-weight: 600;
            letter-spacing: 0.5px;
          }
          @keyframes pop-in-title {
            0% { opacity: 0; transform: scale(0.8) translateY(-30px);}
            100% { opacity: 1; transform: scale(1) translateY(0);}
          }
          @keyframes pulse-title {
            0% { text-shadow: 0 2px 16px #d9f2e0; }
            100% { text-shadow: 0 4px 32px #00761F; }
          }
          .blog-block .card {
            transition: transform 0.5s cubic-bezier(0.4,0,0.2,1), box-shadow 0.5s cubic-bezier(0.4,0,0.2,1);
            height: 100%;
            display: flex;
            flex-direction: column;
            border: none;
            border-radius: 1.2rem;
            box-shadow: 0 4px 24px rgba(59,45,214,0.07);
            background: #fff;
            overflow: hidden;
            position: relative;
          }
          .blog-block .card:hover {
            transform: translateY(-12px) scale(1.05) rotate(-1deg);
            box-shadow: 0 12px 32px rgba(0, 118, 31, 0.18);
            z-index: 2;
            border: 2px solid #00761F;
          }
          .blog-block .card-img-top, .blog-block .card > img {
            max-height: 200px;
            object-fit: cover;
            border-top-left-radius: 1.2rem;
            border-top-right-radius: 1.2rem;
            filter: brightness(0.97) saturate(1.1);
            transition: filter 0.4s;
          }
          .blog-block .card:hover .card-img-top, .blog-block .card:hover > img {
            filter: brightness(1.05) saturate(1.2) contrast(1.1);
          }
          .blog-block .card-body {
            flex: 1 1 auto;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            padding: 1.5rem 1.25rem 1.25rem 1.25rem;
            background: linear-gradient(120deg, #f8fafc 80%, #d9f2e0 100%);
          }
          .blog-block .card-title {
            font-size: 1.18rem;
            margin-bottom: 0.5rem;
            font-weight: 700;
            color: #00761F;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .blog-block .card-text {
            flex: 1 1 auto;
            font-size: 1.01rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            color: #22223b;
          }
          .blog-block time {
            font-size: 0.93rem;
            color: #00761F;
            margin-bottom: 0.5rem;
            display: block;
            font-weight: 600;
            letter-spacing: 0.2px;
          }
          .blog-block .card-animate {
            box-shadow: 0 2px 12px rgba(59,45,214,0.06);
          }
        `}
      </style>
      <Container fluid>
      <div
        className="title-holder-modern py-5 px-3 px-md-4"
        style={{
          marginBottom: '2.5rem',
          marginTop: '-50px',
          textAlign: 'center',        
          display: 'flex',            
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <h2 className="section-title">
          Eventos em Destaque!
        </h2>
        <p className="section-subtitle">
          Participe das nossas atividades e viva experiências inesquecíveis.
        </p>
        <div className="section-underline"></div>
      </div>
        <Row>
          
          {
            blogData.map((blog, idx) => (
              <Col sm={4} key={blog.id}>
                <Link to={`/evento/${blog.id}`} style={{ textDecoration: 'none' }}>
                  <Card
                    className="card-animate"
                    ref={el => cardRefs.current[idx] = el}
                  >
                    <Card.Img variant="top" src={blog.image} alt={blog.title} marginBottom='50px' />
                    <Card.Body>
                      <time>{blog.time}</time>
                      <Card.Title>{blog.title}</Card.Title>
                      <Card.Text>
                        {blog.description}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Link>
              </Col>
            ))
          }
        </Row>
        <div className="text-center mt-5 mb-3">
          <Link 
            to="/comunicacao/eventos" 
            className="btn btn-primary btn-events"
            style={{
              backgroundColor: '#00761F',
              borderColor: '#006a1f',
              padding: '12px 28px',
              borderRadius: '50px',
              fontSize: '1.1rem',
              fontWeight: '600',
              letterSpacing: '0.5px',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(0, 118, 31, 0.3)',
              textTransform: 'uppercase',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            Ver todos os eventos
            <i className="fas fa-arrow-right ml-2"></i>
          </Link>
        </div>
      </Container>
    </section>
  );
}

export default AppBlog;